module.exports = __webpack_public_path__ + "img/pega_porcelanato_marmol_granito.e981a423.png";